module.exports = __webpack_public_path__ + "static/media/Axonius.95037343.png";